function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EdgeDetection } from 'xps-react-utils';
import SubNavGroup from './SubNavGroup';
import SubNavItem from './SubNavItem';
import { Row, Col } from '../Layout';
var propTypes = {
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  megamenu: PropTypes.bool,
  colWidth: PropTypes.number,
  handleActiveSubNavItem: PropTypes.func,
  hasActiveSubNavItem: PropTypes.bool
};
var defaultProps = {
  isOpen: false,
  megamenu: false,
  colWidth: 200,
  handleActiveSubNavItem: function handleActiveSubNavItem() {}
};

var SubNav = /*#__PURE__*/function (_Component) {
  _inherits(SubNav, _Component);

  var _super = _createSuper(SubNav);

  function SubNav() {
    var _this;

    _classCallCheck(this, SubNav);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "updateSubnavWidth", function (value) {
      var subnavWidth = _this.state.subnavWidth;
      var colWidth = _this.props.colWidth;
      var newWidth = subnavWidth + value - 24 - 40;

      var numOfColPerWidth = _this.calculateGridColNum(newWidth);

      var newSubNavWidth = numOfColPerWidth * colWidth + 40;
      var newSubNavCol = Math.floor(12 / numOfColPerWidth);

      _this.setState({
        subnavWidth: newSubNavWidth,
        subnavCol: newSubNavCol
      });
    });

    _defineProperty(_assertThisInitialized(_this), "calculateGridColNum", function (width) {
      var _this$props = _this.props,
          colWidth = _this$props.colWidth,
          children = _this$props.children;
      var colNum = Math.floor(width / colWidth);

      switch (colNum) {
        case 5:
          if (children.length === 5) {
            return 5;
          } else {
            return 4;
          }

        case 7:
          if (children.length === 7) {
            return 7;
          } else {
            return 6;
          }

        case 8:
          return 6;

        case 9:
          return 6;

        default:
          return colNum;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateSubNavWidth", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          megamenu = _this$props2.megamenu,
          colWidth = _this$props2.colWidth;

      if (megamenu) {
        var myWidth = children.length * colWidth + 40;

        var numOfColPerWidth = _this.calculateGridColNum(myWidth);

        var newSubNavWidth = numOfColPerWidth * colWidth + 40;
        var newSubNavCol;

        if (children.length === numOfColPerWidth) {
          newSubNavCol = null;
        } else {
          newSubNavCol = Math.floor(12 / numOfColPerWidth);
        }

        _this.setState({
          subnavWidth: newSubNavWidth,
          subnavCol: newSubNavCol
        });
      } else {
        _this.setState({
          subnavWidth: colWidth + 40
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemSelected", function (info) {
      var handleActiveSubNavItem = _this.props.handleActiveSubNavItem;

      _this.setState({
        activeIndex: info.index
      });

      if (info.index !== null) {
        handleActiveSubNavItem();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemSelectedGroup", function (info) {
      var handleActiveSubNavItem = _this.props.handleActiveSubNavItem;

      _this.setState({
        activeIndex: info.item.index,
        activeGroupIndex: info.groupIndex
      });

      if (info.item.index !== null && info.groupIndex !== null) {
        handleActiveSubNavItem();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "buildNewSubNavGroup", function (child, index) {
      var _this$props3 = _this.props,
          hasActiveSubNavItem = _this$props3.hasActiveSubNavItem,
          megamenu = _this$props3.megamenu;
      var _this$state = _this.state,
          activeGroupIndex = _this$state.activeGroupIndex,
          activeIndex = _this$state.activeIndex,
          subnavCol = _this$state.subnavCol;
      var key = "listitem-".concat(index);
      var SubNavGroupComp = /*#__PURE__*/React.createElement(SubNavGroup, _extends({}, child.props, {
        key: key,
        index: index
      }, index === activeGroupIndex && activeIndex !== null && hasActiveSubNavItem && {
        hasActiveSubNavItem: true
      }, {
        handleActiveSubNavItem: _this.handleItemSelectedGroup
      }));

      if (megamenu) {
        return /*#__PURE__*/React.createElement(Col, {
          lg: subnavCol
        }, SubNavGroupComp);
      } else {
        return SubNavGroupComp;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "buildNewSubNavItem", function (child, index) {
      var hasActiveSubNavItem = _this.props.hasActiveSubNavItem;
      var activeIndex = _this.state.activeIndex;
      var key = "listitem-".concat(index);
      return /*#__PURE__*/React.createElement(SubNavItem, _extends({}, child.props, {
        key: key,
        index: index,
        onItemClick: _this.handleItemSelected
      }, index === activeIndex && hasActiveSubNavItem && {
        active: true
      }));
    });

    _this.state = {
      activeIndex: null,
      subnavWidth: 0,
      subnavCol: 12
    };
    return _this;
  }

  _createClass(SubNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateSubNavWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;

      if (isOpen && isOpen !== prevProps.isOpen) {
        var overflows = EdgeDetection.detect(EdgeDetection.getDimensions(this.subnavNode), EdgeDetection.getWindowDimensions());

        if (overflows.length) {
          if (overflows[0].direction === 'right') {
            this.updateSubnavWidth(overflows[0].value);
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          isOpen = _this$props4.isOpen,
          className = _this$props4.className,
          children = _this$props4.children,
          megamenu = _this$props4.megamenu;
      var subnavWidth = this.state.subnavWidth;
      var ntClass = classnames('subnav', 'subnav-skin', 'display-none', {
        'display-block': isOpen
      }, {
        subnav__megamenu: megamenu
      }, className);
      var headerPresent = React.Children.toArray(children).some(function (item) {
        return Array.isArray(item.props.children);
      });
      var newChildren = React.Children.map(children, function (child, index) {
        var newChild;

        if (Array.isArray(child.props.children)) {
          newChild = _this2.buildNewSubNavGroup(child, index);
        } else if (typeof child.props.children === 'string' && headerPresent) {
          // we are telling buildNewSubNavGroup to handle this item as a header even though it has no children
          var _child$props = child.props,
              _children = _child$props.children,
              props = _objectWithoutProperties(_child$props, _excluded);

          newChild = _this2.buildNewSubNavGroup({
            props: props
          }, index);
        } else {
          newChild = _this2.buildNewSubNavItem(child, index);
        }

        return newChild;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: ntClass,
        style: {
          width: subnavWidth
        },
        "aria-hidden": !isOpen,
        ref: function ref(node) {
          _this2.subnavNode = node;
        }
      }, megamenu ? /*#__PURE__*/React.createElement(Row, null, newChildren) : /*#__PURE__*/React.createElement("ul", {
        role: "menu",
        className: "list paddingleft-none"
      }, newChildren));
    }
  }]);

  return SubNav;
}(Component);

SubNav.propTypes = propTypes;
SubNav.defaultProps = defaultProps;
SubNav.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "updateSubnavWidth",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "calculateGridColNum",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "width",
      "type": null
    }],
    "returns": null
  }, {
    "name": "calculateSubNavWidth",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleItemSelected",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "info",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleItemSelectedGroup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "info",
      "type": null
    }],
    "returns": null
  }, {
    "name": "buildNewSubNavGroup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "buildNewSubNavItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "SubNav",
  "props": {
    "isOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "megamenu": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "colWidth": {
      "defaultValue": {
        "value": "200",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "handleActiveSubNavItem": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "hasActiveSubNavItem": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
export default SubNav;